import React from 'react'
import PropTypes from 'prop-types'

import withStyles from '@material-ui/core/styles/withStyles'
import Paper from '@material-ui/core/Paper'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    zIndex: 1,
    height: theme.spacing(4),
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      height: theme.spacing(4),
    },
    [theme.breakpoints.up('sm')]: {
      height: theme.spacing(6),
    },
    [theme.breakpoints.up('md')]: {
      height: theme.spacing(9),
    },
  },
  title: {
    flex: '1 0 auto',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loader: {
    flex: '0 0 auto',
  },
})

const TopBar = ({ classes, title }) => (
  <Paper square className={classes.root}>
    {title ? (
      <div className={classes.title}>
        <Typography color="secondary" variant="body2">{title}</Typography>
      </div>
    ) : null}
    <LinearProgress variant="indeterminate" color="secondary" className={classes.loader} />
  </Paper>
)

TopBar.propTypes = {
  title: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
}

TopBar.defaultProps = {
  title: null,
}

const WithStylesTopBar = withStyles(styles)(TopBar)

export default WithStylesTopBar
